<template>
    <div class="invoiceDetails table-responsive">
        <table class="table table-bordered table-hover">
            <thead>
                <tr>
                    <th>Shipment ID</th>
                    <th>Order number</th>
                    <th>Shipping Method</th>
                    <th>Tracking/BOL</th>
                    <th>ETD</th>
                    <th>ETA</th>
                    <th>Status</th>
                    <th></th>
                    <!-- <th>Open Quantity</th> -->
                </tr>
            </thead>
            <tbody>
                <template
                    v-if="shippingProducts !== null && shippingProducts.length"
                >
                    <template v-for="(product, index) in shippingProducts">
                        
                        <template  v-for="(
                                shipping, shippingIndex
                            ) in product.shippings">
                        <tr
                           
                           
                        >
                            <td><router-link
                                    class="btn btn-primaryship"
                                    :to="{
                                        name: 'purchaseOrderShowShipment',
                                        params: {
                                            id: shipping.purchase_order_id,
                                            shipId: shipping.id,
                                        },
                                    }"
                                >#{{ shipping.id }}</router-link></td>
                            <td>{{ order.order_number }}</td>
                            <td>
                                <template v-if="shipping.carrier_type === 1"
                                    >Air</template
                                >
                                <template v-else>Ocean</template>
                            </td>
                            <td>
                                <a
                                    v-if="
                                        shipping.tracking_no !== null &&
                                        shipping.tracking_no !== ''
                                    "
                                    href="javascript:void(0)"
                                    @click="
                                        getShipmentTracking(
                                            shipping.carrier_company,
                                            shipping.tracking_no
                                        )
                                    "
                                    >{{ shipping.tracking_no }}</a
                                >
                            </td>
                            <td>
                                {{ formatDate(shipping.eta_departure) }}
                            </td>
                            <td>
                                {{ formatDate(shipping.eta_arrival) }}
                            </td>
                            <td>
                                <p
                                    v-if="shipping.status === 1"
                                    class="not-initiated"
                                >
                                    Not initiated
                                </p>
                                <p
                                    v-else-if="shipping.status === 2"
                                    class="dhipped"
                                >
                                    Shipped
                                </p>
                                <p
                                    v-else-if="shipping.status === 3"
                                    class="in-iransit"
                                >
                                    In Transit
                                </p>
                                <p
                                    v-else-if="shipping.status === 4"
                                    class="delivered"
                                >
                                    Delivered
                                </p>
                            </td>
                            <td>

                            <a
                                    class="btn btn-primaryship"
                                    data-toggle="collapse"
                                    @click="
                                        toggleShippingProductDetailId(shipping)
                                    "
                                    :href="'#collapseExample_' + shipping.id"
                                    role="button"
                                    :aria-expanded="
                                        shipping.id == shippingProductDetailId
                                            ? 'true'
                                            : 'false'
                                    "
                                    :aria-controls="
                                        '#collapseExample_' + shipping.id
                                    "
                                >
                                    Shipment details
                                </a>

                            <!-- <a href="javascript:void(0)" class="btn btn-primaryship" @click="showtrInfo(shipping.id,shipping.mbl_number,shipping.id)">
                                Shipment details
                            </a> -->
                                <!-- <router-link
                                    class="btn btn-primaryship"
                                    :to="{
                                        name: 'purchaseOrderShowShipment',
                                        params: {
                                            id: shipping.purchase_order_id,
                                            shipId: shipping.id,
                                        },
                                    }"
                                >
                                    Shipment details
                                </router-link> -->
                                <!-- <a
                                class="btn btn-primaryship"
                                    @click="
                                        getShippingDetails(
                                            shipping.mbl_number
                                        )
                                    "
                                >
                                    Shipment details
                                </a> -->
                            </td>

                            
                        </tr>
                        
                       <template v-if="shipping.id == shippingProductDetailId">
                       
                             <tr>
                            <td></td>
                            <td colspan="7" class="border-none">
                                <div class="dropdown2">
                                <div class="collapse" :class="shipping.id == shippingProductDetailId ? 'show' : null" :id="'#collapseExample_' + shipping.id">
                                <table class="table table-bordered table-hover">
                                    <thead>
                                        <tr :key="'child_detail_tr_' + index">
                                            <th>Product Id</th>
                                            <th>Product Name</th>
                                            <th>Description</th> 
                                            <th>Ordered Quantity</th>
                                            <th>Shipped quantity</th>
                                            <th>Cases</th>
                                            <th>Pallets</th>
                                            <th>Total shipped</th>
                                            <!-- <th>Shipping Method</th>
                                            <th>Carrier</th>
                                            <th>Terminal</th> -->
                                            
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- <tr
                                            v-for="(
                                                shipping, shippingIndex
                                            ) in product.shippings"
                                            :key="
                                                'child_detail_row_tr_' +
                                                shippingIndex
                                            "
                                        > -->
                                        <template  v-for="(
                                            allProduct, productIndex
                                        ) in shipping.products">
                                        
                                        <tr>
                                            <td>{{ allProduct.product_num }}</td>
                                            <td>{{ allProduct.product_name }}</td>
                                            <td><div v-html="allProduct.product_desc"></div></td>
                                            <td>{{ allProduct.quantity }}</td>
                                            <td>{{ allProduct.pivot.quantity }}</td>
                                            <td>{{ allProduct.pivot.total_cases }}</td>
                                            <td>{{ allProduct.pivot.amount_pallet }}</td>
                                            <td></td>
                                            <!-- <td><template v-if="shipping.carrier_type === 1"
                                                    >Air</template
                                                >
                                                <template v-else>Ocean</template>
                                            </td>
                                            <td>{{ shipping.carrier_company }}</td>
                                            <td>{{ shifl_port_terminal }}</td> -->
                                                
                                           
                                            
                                            
                                            
                                        </tr>

                                    </template>

                                        
                                    </tbody>
                                </table>
                                </div>
                            </div>
                            </td>
                        </tr>
                        </template>

                    </template>
                    </template>
                </template>
                <template v-else> </template>
            </tbody>
        </table>
        <ShippingTrackingModal
            :shipping="shipping"
            :shippingByRef="shippingByRef"
            :order="order"
            :shippingStatus="shippingStatus"
        ></ShippingTrackingModal>

        <ShippingItemsModal
            :shipmentDetails="shipmentDetails"
            :shippingOrderItems="shippingOrderItems"
        ></ShippingItemsModal>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import axios from "axios";
import ShippingTrackingModal from "./ShippingTrackingModal";
import ShippingItemsModal from "./ShippingItemsModal";

export default {
    name: "OrderShipments",
    props: ["order", "po", "loading", "shippingProducts", "bus"],
    components: { ShippingTrackingModal, ShippingItemsModal },
    mounted() {},
    data() {
        return {
            shifl_port_loading:null,
            shifl_port_discharge:null,
            shifl_port_terminal:null,
            indexshow:null,
            hideAndShow:null,
            shippingProductDetailId: null,
            shipmentDetails: [],
            shippingOrderItems: [],
            shippingByRefList: null,
            shippingByRef: null,
            shippingStatus: null,
            shipping: null,
        };
    },
    methods: {
        ...mapActions([
            "setCommonErrors",
            "setErrorMessage",
            "setSuccessMessage",
            "setLoading",
        ]),
        
        showtrInfo(index,mbl_number,shipId){
            // console.log("index",index);
            // return "";
             if(this.hideAndShow == index){
                this.indexshow = null;
                this.hideAndShow = null;
                console.log("here ");
                console.log("indexshow ",this.indexshow);
                console.log("indexshow ",this.hideAndShow);
                //this.hideAndShow = true;
            }
            else{
                console.log("Thhere ");
                this.indexshow = index;
                this.hideAndShow = index;
                console.log("indexshow ",this.indexshow);
                console.log("indexshow ",this.hideAndShow);
            }
            //this.indexshow = index
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("po.getShppingNumberByMbl", {
                        id: shipId,
                    }),
                    { mbl_number: mbl_number },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        console.log("data shfl shipping number : ", data);
                        
                        this.shifl_port_loading = data.shipment_detail ? data.shipment_detail.location_from : "";
                        this.shifl_port_discharge = data.shipment_detail ? data.shipment_detail.port_of_discharge : "";
                        this.shifl_port_discharge = data.data ? data.data.terminal : "";
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        //this.getOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });

        },

        

        getShipmentTracking(carrierCompany, shipmentNo) {
            console.log(" carrierCompany ", carrierCompany);
            console.log(" shipmentNo ", shipmentNo);

            if (carrierCompany == "Maersk Line") {
                window.open(
                    "https://www.maersk.com/tracking/" + shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "Orient Overseas Container Line Ltd.") {
                window.open(
                    "https://www.oocl.com/eng/Pages/default.aspx" + shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "American President Lines") {
                window.open(
                    "https://www.apl.com/ebusiness/tracking/search" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "Ocean Network Express (ONE Line)") {
                window.open(
                    "https://ecomm.one-line.com/one-ecom/manage-shipment/cargo-tracking?trakNoParam=" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "ZIM Integrated Shipping Services Ltd") {
                window.open(
                    "https://www.zim.com/tools/track-a-shipment?consnumber=" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "COSCO Container Lines") {
                window.open(
                    "https://elines.coscoshipping.com/ebusiness/cargoTracking?trackingType=BILLOFLADING&number=" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "Hapag Lloyd Container Line/A") {
                window.open(
                    "https://www.hapag-lloyd.com/en/online-business/track/track-by-booking.html?blno=" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "Evergreen Line") {
                window.open(
                    "https://connect.track-trace.com/for/superbpackaging/billoflading/" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "Turkon Line Inc") {
                window.open(
                    "https://my.turkon.com/container-tracking" + shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "Transfer") {
                window.open(
                    "https://www.transfarshipping.com/tracking?blNo=" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "MSC") {
                window.open(
                    "https://www.msc.com/en/track-a-shipment",
                    "_blank"
                );
            } else if (carrierCompany == "Wan Hai Lines") {
                window.open(
                    "https://www.wanhai.com/views/Main.xhtml",
                    "_blank"
                );
            } else if (carrierCompany == "TS Lines") {
                window.open(
                    "https://vgm.tslines.com/CargoTracking/CargoTrackingBL",
                    "_blank"
                );
            } else if (carrierCompany == "SM Line") {
                window.open(
                    "https://esvc.smlines.com/smline/CUP_HOM_3301.do",
                    "_blank"
                );
            } else if (carrierCompany == "Yang Ming Line") {
                window.open(
                    "https://www.yangming.com/e-service/Track_Trace/track_trace_cargo_tracking.aspx?str=" +
                        shipmentNo +
                        "&rdolType=BL",
                    "_blank"
                );
            } else if (carrierCompany == "Hyundai Merchant Marine Co., Ltd.") {
                window.open(
                    "https://www.hmm21.com/e-service/general/DashBoard.do",
                    "_blank"
                );
            } else if (carrierCompany == "Hamburg Sud") {
                window.open(
                    "https://www.hmm21.com/e-service/general/DashBoard.do",
                    "_blank"
                );
            } else if (carrierCompany == "Compagnie Maritime d Affretement Compagnie Generale Maritime") {
                window.open(
                    "https://www.cma-cgm.com/ebusiness/tracking",
                    "_blank"
                );
            } else if (carrierCompany == "UPS") {
                window.open(
                    "https://www.ups.com/track?loc=en_US&requester=ST/",
                    "_blank"
                );
            } else if (carrierCompany == "Fedex") {
                window.open(
                    "https://www.fedex.com/fedextrack/no-results-found?trknbr=" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "DHL") {
                window.open(
                    "https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id=" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "Other") {
            } else {
            }
        },
        getShippingDetails(mblNumber) {
            console.log("mblNumber mblNumbe r", mblNumber);
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("po.getShppingNumberByMbl", {
                        id: this.order.id,
                    }),
                    { mbl_number: mblNumber },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        console.log("data shiipng number : ", data);
                        this.shipmentDetails = data.data.data;
                        this.showShimpment = true;
                        this.shipmentId = data.data.data.shipment_id;
                        console.log("this.shipmentId : ", this.shipmentId);
                        this.shippingOrderItems = data.orders;
                        $("#shippingTrackingModal1").modal("show");
                        console.log(
                            "this.shippingOrderItems ",
                            this.shippingOrderItems
                        );
                        // this.setSuccessMessage(
                        //     "Label added to this order successfully!"
                        // );
                        //this.isEditLabelSection = false;
                        //this.newLabelId = [];
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        //this.getOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },

        toggleShippingProductDetailId(product) {
            if (this.shippingProductDetailId === product.id) {
                this.shippingProductDetailId = null;
            } else {
                this.shippingProductDetailId = product.id;
            //     let self = this;
            // this.setLoading(true);
            // this.setCommonErrors([]);
            // this.setErrorMessage(null);
            // return axios
            //     .post(
            //         window.route("po.getShppingNumberByMbl", {
            //             id: product.id,
            //         }),
            //         { mbl_number: product.mbl_number },
            //         {
            //             validateStatus: function (status) {
            //                 return status < 500; // Resolve only if the status code is less than 500
            //             },
            //         }
            //     )
            //     .then(({ data }) => {
            //         if (data.errorMessage) {
            //             self.setErrorMessage(data.errorMessage);
            //             if (data.errors) {
            //                 self.setCommonErrors(data.errors);
            //             }
            //         } else {
            //             console.log("data shfl shipping number : ", data);
                        
            //             this.shifl_port_loading = data.shipment_detail ? data.shipment_detail.location_from : "";
            //             this.shifl_port_discharge = data.shipment_detail ? data.shipment_detail.port_of_discharge : "";
            //             this.shifl_port_discharge = data.data ? data.data.terminal : "";
            //             setTimeout(() => {
            //                 self.setSuccessMessage(null);
            //             }, 5000);
            //             //this.getOrder();
            //         }
            //     })
            //     .catch((error) => {
            //         self.setErrorMessage(
            //             error.response && error.response.errorMessage
            //                 ? error.response.errorMessage
            //                 : error.message
            //         );
            //     })
            //     .finally(() => {
            //         self.setLoading(false);
            //     });
            }
            this.$emit(
                "toggleShippingProductDetailIdEvent",
                this.shippingProductDetailId
            );
        },
        getShippingQuantityByStatus(product, status) {
            let total = 0;
            if (status) {
                product.shippings
                    .filter((x) => x.status === status)
                    .forEach((x) => {
                        total += x.pivot.quantity;
                    });
            } else {
                product.shippings.forEach((x) => {
                    total += x.pivot.quantity;
                });
            }

            return total;
        },
        getShipmentStatusById(id) {
            let self = this;
            this.shippingStatus = null;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios
                .get(
                    window.route("so.getShipmentStatusById", {
                        id: this.order.id,
                        shipment_id: id,
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        //console.log(data.data);
                        this.shippingStatus = data.data.data;

                        $("#shippingTrackingModal").modal("show");
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getShipmentByRef(shipping, id) {
            this.shipping = _.cloneDeep(shipping);
            let self = this;
            this.shippingStatus = null;
            this.shippingByRefList = null;
            this.shippingByRef = null;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios
                .get(
                    window.route("so.getShipmentByRef", {
                        id: this.order.id,
                        tracking_no: id,
                        type: "BYCONTAINER",
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        //console.log(data.data);
                        if (data.data.success) {
                            this.shippingByRefList = _.cloneDeep(
                                data.data.data
                            );
                            let shippings =
                                data.data.data.BYCONTAINER.Active.filter(
                                    (x) => x["MBL#"] == id
                                );
                            if (shippings.length) {
                                this.shippingByRef = _.cloneDeep(shippings[0]);
                                //console.log(shippings[0]['Shifl Ref#'])
                                //console.log(shippings[0]['Shifl Ref#'].substr(1, shippings[0]['Shifl Ref#'].length))
                                //let ship_id = shippings[0]['Shifl Ref#'].substr(1, shippings[0]['Shifl Ref#'].length);
                                //this.getShipmentStatusById(ship_id);
                            } else {
                                shippings =
                                    data.data.data.BYCONTAINER.Completed.filter(
                                        (x) => x["MBL#"] == id
                                    );
                                if (shippings.length) {
                                    this.shippingByRef = _.cloneDeep(
                                        shippings[0]
                                    );
                                    //let ship_id = shippings[0]['Shifl Ref#'].substr(1, shippings[0]['Shifl Ref#'].length);
                                    //this.getShipmentStatusById(ship_id);
                                }
                            }
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);

                    if (this.shippingByRef) {
                        let ship_id = this.shippingByRef["Shifl Ref#"].substr(
                            1,
                            this.shippingByRef["Shifl Ref#"].length
                        );
                        this.getShipmentStatusById(ship_id);
                    }
                });
        },
    },
    computed: {},
    watch: {},
};
</script>

<style scoped></style>
